import { Network, Token } from '@sdk/shared/types/config.types';
import { getNetworkIconUrl, getTokenIconUrl } from '@sdk/utils/config';

export type NetworkWithIcon = Network & { iconUrl?: string };

export const mapNetworkToIcon = <T extends { name: string }>(
  network: T,
): T & { iconUrl: string } => {
  const iconUrl: string = getNetworkIconUrl(network.name);

  return {
    ...network,
    iconUrl,
  };
};
export const mapTokenToIcon = (token: Token): Token => {
  const icon: string = getTokenIconUrl(token.name);

  return {
    ...token,
    icon,
  };
};
